/** Σφάλμα εκτέλεσης (π.χ. διαίρεση με το μηδέν, μη αρχικοποιημένη μεταβλητή). */
export class RuntimeError extends Error {
  readonly line: number;
  readonly column: number;

  constructor(message: string, line: number, column: number) {
    super(message);
    this.name = 'RuntimeError';
    this.line = line;
    this.column = column;
  }
}
